var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "admin-forms" } },
    [
      _c("nav", { staticClass: "tabnav" }, [
        _c("ul", [
          _c(
            "li",
            {
              staticClass: "bg-white",
              class: { active: _vm.showImport },
              on: {
                click: function($event) {
                  _vm.showImport = true
                }
              }
            },
            [
              _c("p", { staticClass: "text-small blueDark" }, [
                _vm._v(_vm._s(_vm.$t("actions.import")))
              ])
            ]
          ),
          _c(
            "li",
            {
              staticClass: "bg-white",
              class: { active: !_vm.showImport },
              on: {
                click: function($event) {
                  _vm.showImport = false
                }
              }
            },
            [
              _c("p", { staticClass: "text-small blueDark" }, [
                _vm._v(_vm._s(_vm.$t("actions.export")))
              ])
            ]
          )
        ])
      ]),
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "ma-form-import",
            _vm._g(
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showImport,
                    expression: "showImport"
                  }
                ],
                key: "import" + _vm.importForm.key,
                attrs: {
                  filterFormOptions: _vm.filterFormOptions,
                  isLoading: _vm.isLoading,
                  mimetypeAccepted: _vm.mimetype
                }
              },
              _vm.importFormEvents
            )
          ),
          _c(
            "ma-form-export",
            _vm._g(
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.showImport,
                    expression: "!showImport"
                  }
                ],
                key: "export" + _vm.exportForm.key,
                attrs: {
                  filterFormOptions: _vm.filterFormOptions,
                  isLoading: _vm.isLoading
                }
              },
              _vm.exportFormEvents
            )
          )
        ],
        1
      ),
      _c(
        "ma-modal",
        { ref: "adminFormModal", attrs: { type: "large", canClose: false } },
        [
          _c("template", { slot: "modalContent" }, [
            _c(
              "div",
              {
                staticClass:
                  "grid grid--column grid--ai-middle grid--jc-middle grid--full-height"
              },
              [
                _c("div", { staticClass: "spinner-symbol mg mg--b-6" }),
                _c("h2", { staticClass: "headline-medium black mg mg--b-2" }, [
                  _vm._v(_vm._s(_vm.$t("adminForms.modal.title")))
                ]),
                _c("p", { staticClass: "text-medium mg mg--b-3" }, [
                  _vm._v(_vm._s(_vm.$t("adminForms.modal.description")))
                ])
              ]
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }